import { ApprovalsInsightCard } from './ApprovalsInsightCard';
import { CommunicationsByCategoryCard } from './CommunicationsByCategoryCard';
import { OverviewRecentCommunicationsCard } from './OverviewRecentCommunicationsCard';
import { OverviewStatsCard } from './OverviewStatsCard';
import { SubmissionsInsightCard } from './SubmissionsInsightCard';

interface OverviewTabProps {
    practiceId: string;
    onGoToCommunicationsTab: () => void;
}

// Mirrors CommunicationsTab/PatientsTab: mounting IS the "tab is active" signal
// (see PracticeDetail.tsx). No V1/V2 split, no "Open action items" card.
export function OverviewTab({ practiceId, onGoToCommunicationsTab }: OverviewTabProps) {
    return (
        <div className="pb-8 flex flex-col gap-4">
            <OverviewStatsCard practiceId={practiceId} />
            <div className="grid grid-cols-2 gap-4">
                <SubmissionsInsightCard practiceId={practiceId} />
                <ApprovalsInsightCard practiceId={practiceId} />
            </div>
            <div className="grid grid-cols-[3fr_2fr] gap-4">
                <OverviewRecentCommunicationsCard
                    practiceId={practiceId}
                    onGoToCommunicationsTab={onGoToCommunicationsTab}
                />
                <CommunicationsByCategoryCard practiceId={practiceId} />
            </div>
        </div>
    );
}
